import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastMessageOptions } from 'primeng/api';

import { GlobalCommunication } from '../../../global-communication.service';
import { CurrentUser } from '../../../models/current-user.model';
import { AuthService } from '../../../services/auth.service';
import { UsersService } from '../../../services/users.service';

@Component({
  selector: 'nb-login',
  templateUrl: './login.component.html',
  standalone: false,
})
export class NbLoginComponent {
  public model: {
    username: string;
    password: string;
  } = { username: '', password: '' };
  public submitted: boolean = false;
  public errors: ToastMessageOptions[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private globalCommunication: GlobalCommunication,
  ) {
    if (authService.isLoggedIn()) {
      this.router.navigate(['/pages']);
    }
  }

  public login(): void {
    this.submitted = true;
    this.authService.login(this.model.username, this.model.password).subscribe(
      () => {
        this.usersService.currentUser().subscribe((currentUser: CurrentUser) => {
          if (currentUser.permissionIds.length) {
            this.router.navigate(['/pages']);
          } else {
            this.authService.logout();
            this.usersService.clearCurrentUser();
            this.globalCommunication.showMessages([
              {
                severity: 'error',
                detail: 'User have to be an Admin or a Project Manager',
              },
            ]);
            this.router.navigate(['/']);
          }
        });
      },
      () => {
        this.errors = [
          {
            severity: 'error',
            detail: 'Username or Password mismatch',
          },
        ];
      },
    );
  }
}
